// removed by extract-text-webpack-plugin
module.exports = {"distanceText":"distanceText__1kqsC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Network/coms/SignalCoverageView/styles.scss
// module id = 2306
// module chunks = 1